import { IRawStyle } from "@fluentui/react";
import React from "react";
import { ContentSection, GridRow, GridColumn, LabeledText } from "sprint-common-web";

import { CloudAudioTechnical } from "../../../../CloudAssetDetails";

interface CloudAudioTechnicalSectionProps {
    technical: CloudAudioTechnical;
    isLoading: boolean;
    style?: IRawStyle;
}

export const CloudAudioTechnicalSection: React.FunctionComponent<CloudAudioTechnicalSectionProps> = (
    props: CloudAudioTechnicalSectionProps
) => {
    const { technical, isLoading, style } = props;

    return (
        <ContentSection header="Technical" isLoading={isLoading} style={style}>
            <GridRow>
                <GridColumn sm={3}>
                    <LabeledText label="Duration" testId="cloud-technical-duration" value={technical.duration} />
                    <LabeledText label="Channels" testId="cloud-technical-channels" value={technical.channelsCount} />
                </GridColumn>
                <GridColumn sm={3}>
                    <LabeledText label="Bitrate" testId="cloud-technical-audioBitRate" value={technical.audioBitRate} />
                    <LabeledText label="Sample rate" testId="cloud-technical-sampleRate" value={technical.sampleRate} />
                </GridColumn>
                <GridColumn sm={3}>
                    <LabeledText
                        label="Audio format"
                        testId="cloud-technical-audioFormat"
                        value={technical.audioFormat}
                    />
                </GridColumn>
            </GridRow>
        </ContentSection>
    );
};
